import { Component, OnInit, OnDestroy } from "@angular/core";
import { FullScreenLoaderService } from "./full-screen-loader.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TenantService } from "../../services/tenant.service";

@Component({
  selector: "full-screen-loader",
  templateUrl: "./full-screen-loader.component.html",
  styleUrls: ["./full-screen-loader.component.scss"]
})
export class FullScreenLoaderComponent implements OnInit, OnDestroy {
  // declarations
  visible = false;
  private _unsubscribeAll: Subject<any> = new Subject();
  tenantConfig = this._tenantService.getTenantConfig();

  constructor(
    private _fullScreenLoader: FullScreenLoaderService,
    private _tenantService: TenantService
  ) {}

  ngOnInit(): void {
    // Visible
    this._fullScreenLoader.visible
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((visible) => {
        this.visible = visible;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
